import { defineNuxtPlugin, useRequestHeaders, useRequestURL, useRuntimeConfig } from "nuxt/app";
import { isCefSharpInvalidError } from "../bugsnagClientFilters.js";
import log from "../log.js";
import { filterExpectedServerErrors } from "../serverErrorHandler.js";
import { addServerStackTraceRewrite } from "../serverStackTracePaths.js";
export default defineNuxtPlugin({
  enforce: "post",
  setup(nuxtApp) {
    const config = useRuntimeConfig();
    const context = {
      bugsnagClient: nuxtApp.$bugsnag,
      // `process.env.STAGE` is unset at runtime, so `log()` reads the stage from here instead.
      stage: config.public.STAGE
    };
    const bugsnagClient = nuxtApp.$bugsnag;
    if (import.meta.client && typeof bugsnagClient?.addOnError === "function") {
      bugsnagClient.addOnError((event) => {
        const message = event.errors?.[0]?.errorMessage ?? "";
        if (/^ResizeObserver loop (?:completed with undelivered notifications|limit exceeded)/i.test(message))
          return false;
        if (/<no response>\s*(?:Load failed|Failed to fetch|NetworkError)/i.test(message)) return false;
        return true;
      });
    }
    if (import.meta.client && typeof bugsnagClient?.addOnError === "function") {
      bugsnagClient.addOnError((event) => {
        const message = event.errors?.[0]?.errorMessage ?? "";
        if (/^Unable to preload CSS for \S+$/i.test(message)) return false;
        return !/^(?:Failed to fetch dynamically imported module(?::.*)?|Importing a module script failed\.?|error loading dynamically imported module(?::.*)?)$/i.test(
          message
        );
      });
    }
    if (import.meta.client && typeof bugsnagClient?.addOnError === "function") {
      bugsnagClient.addOnError((event) => !isCefSharpInvalidError(event));
    }
    if (import.meta.client && typeof bugsnagClient?.addOnError === "function") {
      bugsnagClient.addOnError((event) => {
        const message = event.errors?.[0]?.errorMessage ?? "";
        const file = event.errors?.[0]?.stacktrace?.[0]?.file ?? "";
        if (/^(?:SyntaxError:\s*)?Unexpected end of input$/i.test(message) && /\/misc\/ptm(?:$|[/?:])/.test(file))
          return false;
        return true;
      });
    }
    if (import.meta.server) {
      nuxtApp.hook("app:created", (vueApp) => {
        const errorHandler = filterExpectedServerErrors(vueApp.config.errorHandler);
        if (errorHandler) vueApp.config.errorHandler = errorHandler;
      });
      if (typeof bugsnagClient?.addOnError === "function") {
        const appName = config.public.options?.appName;
        addServerStackTraceRewrite(bugsnagClient, appName);
      }
      context.requestHeaders = useRequestHeaders();
      context.requestUrl = useRequestURL().href;
      context.ignoreOptions = config.public.options.ignore;
    }
    return {
      provide: {
        logger: {
          log: (logParams) => log(context, logParams)
        }
      }
    };
  }
});
